module.exports = __webpack_public_path__ + "img/emc.522e0622.svg";